import sqftShapeManager from "../store/sqftShapeManager";
import workspace from "./workspace";
import config from "../store/sqftConfig";
import store from "../../../../../store";
import $ from "jquery";
import sqftShape from "./shapes/sqftShape";
import {getMidPoint} from "../../../helpers/sqftHelper";
import slabWorkspace from "./slab/slabWorkspace";

const workspaceZoom = function () {
  this.zoomToFeature = (sqftFeature) => {
    let shape = sqftShapeManager.getShapeById(sqftFeature.sqftId);
    if (shape && shape.part === 'line') {
      const line = workspace.getLineById(shape.attachedToId);
      this.zoomToLine(line);

      return;
    }

    if (!(shape instanceof(sqftShape))) {
      return
    }

    this.zoomToShape(shape);
  }

  this.zoomToLine = (line) => {
    let shape = line.getParent();
    let shapePos = shape.getPosition();
    const scale = config.scale;
    const canvas = workspace.getCanvas();
    const sqftPoup = $(".sqft-popupv2");
    const popUpWidth = sqftPoup[0] ? sqftPoup[0].offsetWidth : 0;

    const midPoint = getMidPoint(line.from, line.to);

    let newWorkspacePos = {
      x: (shapePos.x + midPoint.x) * scale - (canvas.width - popUpWidth) / 2,
      y: (shapePos.y + midPoint.y) * scale - canvas.height / 2,
    }

    line.blink.setHighlighting(true);
    this.zoomTo(newWorkspacePos);
  }

  this.getShapeCenter = (shape, isHalfScreen) => {
    const shapePos = shape.getPosition();
    const shapeMinMax = sqftShapeManager.getMinMax(shape.getLines());
    const scale = config.scale;
    const canvas = workspace.getCanvas();
    const sqftPoup = $(".sqft-popupv2");
    const state = store.getState();
    const {sqftFeaturesPopup} = state.sqftState;
    const popUpWidth = sqftPoup[0] && sqftFeaturesPopup.opened ? sqftPoup[0].offsetWidth : 0;

    let newWorkspacePos = {
      x: shapePos.x * scale - (canvas.width - popUpWidth) / 2 + shapeMinMax.width / 2 * scale,
      y: shapePos.y * scale - canvas.height / 2 + shapeMinMax.height / 2 * scale,
    }

    if (isHalfScreen) {
      newWorkspacePos.x = newWorkspacePos.x + canvas.width / 4;
    }

    return newWorkspacePos
  }

  this.zoomToShape = (shape, isHalfScreen = false, timeout = 1) => {
    const newWorkspacePos = this.getShapeCenter(shape, isHalfScreen);
    this.zoomTo(newWorkspacePos, timeout);
    shape.shapeRender.blink.setHighlighting(true);
  }

  this.zoomToSlabShape = (shape, isHalfScreen = false) => {
    let shapePos = shape.getPosition();
    const shapePosSlab = shape.getSlabPosition();
    const shapePosRegular = shape.getRegularPosition();
    const posDiff = {x: shapePosSlab.x - shapePosRegular.x, y: shapePosSlab.y - shapePosRegular.y}
    const workspacePos = workspace.getPosition();
    const shapeMinMax = sqftShapeManager.getMinMax(shape.getLines());
    const scale = config.scale;
    const canvas = workspace.getCanvas();
    const sqftPoup = $(".sqft-popupv2");
    const popUpWidth = sqftPoup[0] ? sqftPoup[0].offsetWidth : 0;

    let newWorkspacePos = {
      x: shapePos.x * scale - (canvas.width - popUpWidth) / 2 + shapeMinMax.width / 2 * scale - workspacePos.x - posDiff.x * scale,
      y: shapePos.y * scale - canvas.height / 2 + shapeMinMax.height / 2 * scale - workspacePos.y - posDiff.y * scale,
    }
    if (isHalfScreen) {
      newWorkspacePos.x = newWorkspacePos.x + canvas.width / 4;
    }

    this.zoomToInSlab(newWorkspacePos);
  }

  this.zoomTo = (newWorkspacePos, timeout = 1) => {
    let workspacePos = workspace.getPosition();
    let isXIncrementUp = newWorkspacePos.x >= workspacePos.x;
    let isYIncrementUp = newWorkspacePos.y >= workspacePos.y;

    let updateWorkspacePos = () => {
      if (Math.ceil(workspacePos.x) === Math.ceil(newWorkspacePos.x)
        && Math.ceil( workspacePos.y) === Math.ceil(newWorkspacePos.y)
      ) {
        clearInterval(refreshIntervalId);
      }

      let incrementX = Math.abs((Math.abs(newWorkspacePos.x) + Math.abs(workspacePos.x)) / newWorkspacePos.x * config.zoomSpeed);
      let incrementY = Math.abs((Math.abs(newWorkspacePos.y) + Math.abs(workspacePos.y)) / newWorkspacePos.y * config.zoomSpeed);

      workspacePos = {
        x: isXIncrementUp
          ? workspacePos.x >= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x + incrementX
          : workspacePos.x <= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x - incrementX,
        y: isYIncrementUp
          ? workspacePos.y >= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y + incrementY
          : workspacePos.y <= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y - incrementY,
      }

      workspace.setPosition(workspacePos);
    };
    let refreshIntervalId = setInterval(updateWorkspacePos, timeout);
  }

  this.zoomToInSlab = (newWorkspacePos) => {
    let workspacePos = slabWorkspace.getPos();
    let isXIncrementUp = newWorkspacePos.x >= workspacePos.x;
    let isYIncrementUp = newWorkspacePos.y >= workspacePos.y;

    let updateWorkspacePos = () => {
      if (Math.ceil(workspacePos.x) === Math.ceil(newWorkspacePos.x)
        && Math.ceil( workspacePos.y) === Math.ceil(newWorkspacePos.y)
      ) {
        clearInterval(refreshIntervalId);
      }

      let incrementX = Math.abs((Math.abs(newWorkspacePos.x) + Math.abs(workspacePos.x)) / newWorkspacePos.x * config.zoomSpeed);
      let incrementY = Math.abs((Math.abs(newWorkspacePos.y) + Math.abs(workspacePos.y)) / newWorkspacePos.y * config.zoomSpeed);

      workspacePos = {
        x: isXIncrementUp
          ? workspacePos.x >= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x + incrementX
          : workspacePos.x <= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x - incrementX,
        y: isYIncrementUp
          ? workspacePos.y >= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y + incrementY
          : workspacePos.y <= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y - incrementY,
      }

      slabWorkspace.setPos(workspacePos);
    };
    let refreshIntervalId = setInterval(updateWorkspacePos, 1);
  }
};

export default new workspaceZoom
